import i18n from './i18n/i18n';
import { ReactSession } from 'react-client-session';
// import Functions from "./class/functions";
// import {createProxyMiddleware} from "http-proxy-middleware";
// import {express} from "express";
ReactSession.setStoreType("localStorage");
import axios, { Axios } from "axios";
ReactSession.set("csrf-token", null);
require("./css/all.min.css");

i18n.changeLanguage(ReactSession.get("selectedLanguage"));
require("./css/index.css");

export const config = {
    imgUri: 'https://new.cloudfront.net', //Product
    testStatus: false,
    testUserName:"testuser@ferofen.com",
    testPassword:"9876Mv+.",
    endPointTest:
    {
        // url: 'https://apiv9x.marvelos.com.tr',
        url: 'https://marvelos-apiv9x.marmaris.bel.tr',
        reCaptcha: "6Lc_",
        uploadsImgUri: 'http://localhost:1881/uploads/',
    },
    endPointProduction: {
        reCaptcha: "6Lc_",
        uploadsImgUri: 'http://localhost:1881/uploads/',
    },
    endPointStage: {
        // url: 'https://apiv9x.marvelos.com.tr',
        url: 'https://marvelos-apiv9x.marmaris.bel.tr',
        reCaptcha: '6LfPHSw',
        // uploadsImgUri: 'https://apiv9x.marvelos.com.tr/',
        uploadsImgUri: 'https://apiv9x.marmaris.bel.tr/',
    },
    explorerEndPointTx: 'https://xxx/tx/',
    explorerEndPointAsset: 'https://xxx/asset/',
}